module.exports = __webpack_public_path__ + "img/logo11.2fbceebe.png";